









































import Vue from 'vue'
import { AnonymizationMethod } from '@qurit/anonymizer'

export default Vue.extend({
  props: ['configItem', 'anonymizationMethods', 'inputs', 'constants', 'variables'],
  methods: {
    checkavailability(method: string) {
      const conditionsArray = [
        method == '',
        method == null,
        method == AnonymizationMethod.DeleteValue,
        method == AnonymizationMethod.Empty,
        method == 'keep',
        method == AnonymizationMethod.HashUID,
        method == AnonymizationMethod.Clear,
        method == AnonymizationMethod.Randomize,
      ]
      return conditionsArray.includes(true)
    },
    sortInputs(inputs: any[]) {
      let sorted = []
      sorted.push({ header: 'Constants' })
      const constants = inputs.filter((x) => x.type == 'const')
      sorted = sorted.concat(constants)
      sorted.push({ header: 'Variables' })
      const variables = inputs.filter((x) => x.type == 'var')
      return sorted.concat(variables)
    },
  },
})
